module.exports = __webpack_public_path__ + "static/media/truly_madly.e63e142b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/truly_madly.jpg
// module id = 33
// module chunks = 0